import { render } from "./MbCommentDisp.vue?vue&type=template&id=7c249178"
import script from "./MbCommentDisp.vue?vue&type=script&lang=js"
export * from "./MbCommentDisp.vue?vue&type=script&lang=js"

import "./MbCommentDisp.vue?vue&type=style&index=0&id=7c249178&lang=scss"
script.render = render

export default script